module.exports = __webpack_public_path__ + "img/1faba.a98e911.svg";